<template>
    <v-menu
            bottom
            left
            offset-y
            origin="top right"
            transition="scale-transition"
            v-if="notifications.length > 0"
    >
        <template v-slot:activator="{ attrs, on }">
            <v-btn
                    class="ml-2"
                    min-width="0"
                    text
                    v-bind="attrs"
                    v-on="on"
            >
                <v-badge
                        color="red"
                        overlap
                        v-if="notifications.length > 0"
                        bordered
                >
                    <template v-slot:badge>
                        <span>{{notifications.length}}</span>
                    </template>

                    <v-icon>mdi-bell</v-icon>
                </v-badge>
            </v-btn>
        </template>

        <v-list
                :tile="false"
                nav
        >
            <div>
                <v-list-item
                        v-for="(notification, i) in notifications"
                        :key="`item-${i}`"
                        dance
                        @click="goToService(notification.id)"
                >
                    <v-list-item-title>
                        {{getNotificationTitle(notification)}}
                    </v-list-item-title>
                </v-list-item>
            </div>
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        name: "Notification",
        computed: {
            notifications() {
                return this.$store.getters.serviceChangedNotification
            }
        },
        methods:{
            goToService(serviceId) {
                let routeName = null
                if (this.$store.getters.hasRole(['Administrator', 'ClientManager'])) {
                    routeName = 'ServicesCard'
                } else if (this.$store.getters.hasRole(['Executor'])) {
                    routeName = 'ExecutorServicesCard'
                }

                this.$store.dispatch('removeServiceChangedMessage', serviceId).then(() => {
                    this.$router.push({
                        name: routeName,
                        params: {
                            serviceId: serviceId
                        }
                    })
                    this.$router.go(0)
                })
            },
            getNotificationTitle(notification){
                let notificationStatus = 'Изменена заявка'
                if(notification.history.createdAt === notification.history.modifiedAt){
                    notificationStatus = 'Новая заявка'
                }
                if(this.$store.getters.hasRole(['Executor']) && notification.executorsCnt && notification.executorsCnt === 0){
                    notificationStatus = 'Новая не назначенная заявка'
                }
                return `${notificationStatus} ${notification.number} - ${notification.client ? notification.client.name : ''}`
            }
        }
    }
</script>

<style scoped>

</style>